import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const ONBOARDING_KEY = 'mharher_onboarding_completed';

const OnboardingContext = createContext(null);

export function OnboardingProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user) {
      // Check if user has completed onboarding
      const globalCompleted = localStorage.getItem(ONBOARDING_KEY);
      const userCompleted = localStorage.getItem(`${ONBOARDING_KEY}_${user.id}`);
      
      // Show onboarding if not completed
      if (!globalCompleted && !userCompleted) {
        setShowOnboarding(true);
      }
      setIsChecked(true);
    }
  }, [isAuthenticated, user]);

  const completeOnboarding = useCallback(() => {
    setShowOnboarding(false);
    localStorage.setItem(ONBOARDING_KEY, 'true');
    if (user?.id) {
      localStorage.setItem(`${ONBOARDING_KEY}_${user.id}`, 'true');
    }
  }, [user]);

  const resetOnboarding = useCallback(() => {
    localStorage.removeItem(ONBOARDING_KEY);
    if (user?.id) {
      localStorage.removeItem(`${ONBOARDING_KEY}_${user.id}`);
    }
    setShowOnboarding(true);
  }, [user]);

  return (
    <OnboardingContext.Provider value={{
      showOnboarding,
      isChecked,
      completeOnboarding,
      resetOnboarding
    }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboardingContext() {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboardingContext must be used within an OnboardingProvider');
  }
  return context;
}

export default OnboardingProvider;
